import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { getDocumentData, showAttendanceStatus } from '../Finances/FinancesModal/data';
import { DownloadIcon } from './icons';
import { formatMoney } from '../../utils/lessonsWord';

import './accounts-v2.scss';
import './history-v2.scss';

const ATTENDANCE = {
  1: { key: 'was', label: 'Відвідано' },
  2: { key: 'skip', label: 'Не враховується' },
  3: { key: 'miss', label: 'Пропущено' },
  4: { key: 'miss', label: 'Пропущено' },
};

const FILTERS = [
  { key: 'all', label: 'Усе' },
  { key: 'pay', label: 'Оплати' },
  { key: 'lesson', label: 'Заняття' },
];

const describe = (document) => {
  const { common, isRefund } = getDocumentData(document);
  const isExpenseCorrection = document.type === 'debt-correction' && document.income_expense === 'expense';
  const qty = isRefund || isExpenseCorrection ? -Number(document.qty || 0) : (common ? Number(document.qty || 0) : -1);

  if (isRefund) {
    return { kind: 'pay', title: 'Повернення коштів', tone: 'red', qty };
  }
  if (document.type === 'debt-correction') {
    return { kind: 'pay', title: 'Корегування заборгованості', tone: common ? 'green' : 'red', qty };
  }
  if (document.is_lesson_write_off) {
    return { kind: 'lesson', title: 'Списання згідно договору', tone: 'red', qty };
  }
  if (common) {
    return { kind: 'pay', title: 'Оплата', tone: 'green', qty };
  }

  const state = showAttendanceStatus(document) ? ATTENDANCE[document.attendance_status] : null;

  return { kind: 'lesson', title: 'Заняття', tone: state?.key || 'none', state: state?.label || '', qty };
};

const HistoryV2 = ({ documents, getPdf }) => {
  const [filter, setFilter] = useState('all');

  const rows = useMemo(() => documents.map((document) => ({ document, info: describe(document) })), [documents]);
  const visible = rows.filter((row) => filter === 'all' || row.info.kind === filter);

  if (documents.length === 0) {
    return <p className="hv2-empty">Даних поки немає.</p>;
  }

  return (
    <div className="hv2">
      <div className="hv2-filters" role="tablist" aria-label="Фільтр історії">
        {FILTERS.map((item) => (
          <button
            type="button"
            key={item.key}
            role="tab"
            aria-selected={filter === item.key}
            className={`hv2-filter ${filter === item.key ? 'is-on' : ''}`.trim()}
            onClick={() => setFilter(item.key)}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className="hv2-list">
        {visible.map(({ document, info }, idx) => {
          const { signs, sumClasses } = getDocumentData(document);

          return (
            <div key={`${document.date}-${idx}`} className={`hv2-row hv2-row--${info.tone}`}>
              <span className={`hv2-row__dot hv2-row__dot--${info.tone}`} aria-hidden="true"></span>

              <div className="hv2-row__main">
                <span className="hv2-row__date">{document.date}</span>
                <span className="hv2-row__title">
                  {info.title}
                  {info.state && <span className={`hv2-row__state hv2-row__state--${info.tone}`}>{info.state}</span>}
                </span>

                {info.kind === 'pay' && document.document_number && !document.is_lesson_write_off && (
                  <span className="hv2-row__doc">
                    <button type="button" className="av2-doc__link" onClick={() => window.open(document.document_url, '_blank', 'noopener')}>
                      {document.document_number}
                    </button>
                    {document.show_document_url && (
                      <button type="button" className="av2-doc__icon" aria-label="Завантажити рахунок" onClick={() => getPdf(document.invoice_id)}>
                        <DownloadIcon />
                      </button>
                    )}
                    {document.check_id && (
                      <button type="button" className="v2-link hv2-row__check" onClick={() => window.open(document.checkbox_url, '_blank', 'noopener')}>
                        Чек
                      </button>
                    )}
                  </span>
                )}
              </div>

              <div className="hv2-row__side">
                <span className={`hv2-row__qty ${info.qty > 0 ? 'is-plus' : 'is-minus'}`}>
                  {info.qty > 0 ? `+${info.qty}` : info.qty} {Math.abs(info.qty) === 1 ? 'заняття' : 'занять'}
                </span>
                <b className={`hv2-row__sum ${sumClasses}`}>{signs}{formatMoney(document.total_price)} грн</b>
              </div>
            </div>
          );
        })}
        {visible.length === 0 && <p className="hv2-empty">Тут поки нічого немає.</p>}
      </div>
    </div>
  );
};

HistoryV2.propTypes = {
  documents: PropTypes.array.isRequired,
  getPdf: PropTypes.func.isRequired,
};

export default HistoryV2;
